<footer class="mt-1">

    <div class="px-md-5 px-2">

        <div class="row gx-0 gy-0">

            <div class="col-md-3">
                <div>
                    <h4>درباره ما</h4>

                    <p style="line-height: 30px;font-size: 15px;font-weight: normal;" class=" text-main my-3">

                        سامانه امدادران با هدف ارائه خدمات سریع و حرفه ای در زمینه امداد خودرو و جرثقیل سیار راه اندازی شده است. با تیم متخصص و تجهیزات پیشرفته، آماده رفع خرابیها، تصادفات و حمل ایمن خودرو هستیم.

                    </p>

                </div>

            </div>

            <div class="col-md-3">
                <div>
                    <h4> لینک های مفید</h4>

                    <ul class="linksuse">

                        <li class="">

                            <a class="text-white" href="https://rayanandisheh.com" target="_blank">

                                شرکت مهندسی رایان اندیشه نصر 

                            </a>

                        
                        </li>

                        <li class="">

                            <a class="text-white" href="https://taxilon.com" target="_blank">

                                درخواست تاکسی بین شهری 

                            </a>
                        
                        </li>
                        
                        <li class="">

                            <a class="text-white" href="https://tr.taxilon.com" target="_blank">

                                تاکسی لون ترکیه 

                            </a>
                        
                        </li>
                        
                        <li class="">

                            <a class="text-white" href="https://fleetyar.com" target="_blank">

                                مدیریت ناوگان و ردیاب خودرویی 

                            </a>

                        
                        </li>
                        
                        <li class="">

                            <a class="text-white" href="https://shahrnik.com" target="_blank">

                                ارتباط مردمی و 137 شهرداری

                            </a>

                        
                        </li>
                        
                        <li class="">

                            <a class="text-white" href="https://didarba.ir" target="_blank">

                                مدیریت جلسات و موصوبات 

                            </a>

                        
                        </li>
                        
                        <li class="">

                            <a class="text-white" href="https://madonik.ir" target="_blank">

                                مدرسه الکترونیک 

                            </a>

                        
                        </li>

                        <li routerLink="/privacy">حریم خصوصی</li>

                    </ul>

                </div>
            </div>
            <div class="col-md-3">
                <div>
                    <h4> راه های ارتباطی </h4>

                    <ul class="linksuse">
                        <li>
                            {{' ایمیل: info@emdadran.com'}}

                        </li>

                        <li class="d-flex">
                            <span>تلفن:</span>
                            <span class="d-flex mx-1">
                                {{ '  021-77273160-2' | faNum   }}
                            </span>
                        </li>

                        <li>

                            <!-- آدرس : {{ 'تهران – کارگر جنوبی بعد از چهارراه جمهوری پلاک 726 ساختمان 207 طبقه سوم واحد 10 شرکت تعاونی اعضای اتحادیه صنف آهنگران و صنعتگران خودرو' | faNum }} -->

                            آدرس : {{ 'تهران نارمک بزرگراه شهید سلیمانی بعداز چهارراه سرسبز پلاک 640 واحد 8' | faNum }}

                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-3">
                <div>
                    <h4> مارا دنبال کنید</h4>

                    <div class=" social">

                        <div class="links d-flex">

                            <h3>
                                <img src="../../../assets/imgs/Shahrnik_Logo_Public_new.png" alt="امدادران">

                            </h3>

                            <h3 class="mx-3">

                                <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=595422&Code=JsWem5I0YsjIrlg51MmdLSq6W3guNJMj'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=595422&Code=JsWem5I0YsjIrlg51MmdLSq6W3guNJMj' alt='' style='cursor:pointer' code='JsWem5I0YsjIrlg51MmdLSq6W3guNJMj'></a>
                                
                            </h3>

                        </div>

                        <div class="social1">

                            <a target="_blank" href="mailto:{{obj_Social?.strEmail}}">

                                <i class="fa fa-envelope-o" aria-hidden="true"></i>

                            </a>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</footer>

<section class="central flex-column signature">

    <div>



    </div>

    <div class="my-1">

        <a target="_blank">

            <span>


            </span>


        </a>

    </div>

    <div class="mb-2">
        <span>
            <a href="https://rayanandisheh.com/" class="" target="_blank">
                طراحی و توسعه شرکت دانش بنیان رایان اندیشه نصر - {{version | faNum}}
            </a>
        </span>
    </div>

</section>